export type Days = "monday" | "tuesday" | "wednesday" | "thursday" | "friday";

export const days: Days[] = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
];


export type TypeWeek = 'weekly' | 'monthly' |   'daily'

export const weeks: TypeWeek[] = [
  'weekly',
  'monthly',
  'daily'
]

export const DAY_LABELS: Record<Days, string> = {
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
};

export const FREQUENCY_LABELS: Record<TypeWeek, string> = {
  weekly: "Semanal",
  monthly: "Mensual",
  daily: 'Todos los dias'
};